import Message from "../common/Message";
import Input from "../common/Input";
import { useEffect, useRef, useState } from "react";
import useChatbotQuery from "../../hooks/bot/useChatbotQuery";
import IntroText from "../common/IntroText";
import ActionButton from "../Buttons/ActionButton";
import IntroButton from "../Buttons/IntroButton";
import PrivacyAgree from "../Modal/PrivacyAgree";
import { useLocation, useNavigate } from "react-router-dom";
import useTransferStore from "../../hooks/bot/useTransferStore";
import queryString from "query-string";
import useReactGASend from "../../../../hooks/useReactGASend";
import useAssignTime from "./../../hooks/agent/useAssignTime";
import useCheckChatStatus from "#src/features/Incomming/hooks/useCheckChatStatus.js";
import InfoText from "../common/InfoText";
import LandersIntroButton from "../Buttons/LandersIntroButton";

const Chatbot = () => {
  useCheckChatStatus();
  const { search, messageList, userId } = useChatbotQuery();
  const { brandId, number } = useTransferStore();
  const { handleClick } = useAssignTime();
  const inputRef = useRef(null);
  const [showIntroButton, setShowIntroButton] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const scrollRef = useRef();

  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    //챗봇과 채팅 내역 있으면 밑으로 스크롤
    setTimeout(() => {
      const scrollHeight = scrollRef.current?.scrollHeight;
      window.scrollTo({ top: scrollHeight, behavior: "smooth" });
    }, 100);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const isNearBottomOfPage =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 200;
      const isPageHeightGreaterThan200vh =
        document.body.scrollHeight >= window.innerHeight * 2;

      if (isNearBottomOfPage && isPageHeightGreaterThan200vh) {
        setShowIntroButton(true);
      } else {
        setShowIntroButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const queryParams = queryString.parse(location.search);
    if (queryParams.agree) {
      openModal();
    } else {
      closeModal();
    }

    const handlePopState = () => {
      if (location.search.includes("agree=true")) {
        navigate("/chat", { replace: true });
      } else {
        navigate("/landing", { replace: true });
      }
    };

    window.history.pushState(null, "", location.pathname + location.search);

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location.search, navigate]);

  const onKeyDown = async (e) => {
    // 이부분이 sendbird와 chatbot 중 선택 되게 바뀌어야 함 sendUserMessage와 다른것
    if (e.key === "Enter") {
      const message = inputRef.current.value;
      // await sendUserMessage({ message });
      search({ message });
      inputRef.current.value = "";
      // inputRef.current.focus();
      inputRef.current.blur();
    }
  };
  const onSendButtonClick = async () => {
    const message = inputRef.current.value;
    // await sendUserMessage({ message });
    search({ message });
    inputRef.current.value = "";
    // inputRef.current.focus();
    inputRef.current.blur();
  };

  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title, body) => {
    makeEventTrackFn({
      category: "event",
      action: title,
      body,
    });
  };
  return (
    <div className="pt-8 pb-12" ref={scrollRef}>
      {brandId === "LD" ? 
        <InfoText desc={"※ AI챗봇 랜디의 답변은 정확하지 않을 수 있습니다."} /> : 
        (<IntroText
          title={"무엇을\n도와드릴까요?"}
          desc={"아래 버튼을 눌러 궁금한 점을 해결해 보세요."}
        />)
      }
      <Message messageMap={messageList} search={search} userId={userId} />
      <Input
        onKeyDown={onKeyDown}
        onSendButtonClick={onSendButtonClick}
        inputRef={inputRef}
        search={search}
        brandId={brandId}
      />
      {(brandId === "EM" || brandId === "TR") && (
        <ActionButton
          onClick={() => {
            handleClick();

            trackButtonClick("채팅 상담(오른쪽 상단)", {
              data_btn_nm: "채팅상담",
            });
          }}
        >
          상담원연결
        </ActionButton>
      )}
      {(brandId === "NB" || brandId === "ED") && (
        <ActionButton
          tel
          number={number}
          onClick={() => {
            trackButtonClick("점포 연결 요청(오른쪽 상단)", {
              data_btn_nm: "점포 연결 요청",
            });
          }}
        >
          점포연결
        </ActionButton>
      )}
      {brandId === "ED" && (
          <ActionButton
            brandId={brandId}
            number={number}
            onClick={() => {
              window.location.href = "https://www.emarteveryday.co.kr/customer/consultWrite.jsp";

              trackButtonClick("온라인 접수(오른쪽 상단)", {
                data_btn_nm: "온라인 접수",
              });
            }}
          >
            온라인접수
          </ActionButton>
        )
      }

      {showIntroButton && (
        brandId === "LD" ? (
          <LandersIntroButton 
            onClick={() =>
              search({ message: '{"type":"GREET_RESPOND_NORMAL","message":""}' })
            }
          >
          처음으로
        </LandersIntroButton>
        ) : (
          <IntroButton
            brandId={brandId}
            onClick={() =>
              search({ message: '{"type":"GREET_RESPOND_NORMAL","message":""}' })
            }
          >
            처음으로
          </IntroButton>
        )
      )}

      <PrivacyAgree isOpen={modalIsOpen} onRequestClose={closeModal} />
    </div>
  );
};

export default Chatbot;
